var React = require('react');

function VenusMars (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M576 12v79a12 12 0 0 1-12.1 12 11.73 11.73 0 0 1-8.4-3.5l-16.9-16.9-48.7 48.7a144 144 0 0 1-211.1 189.8 174.74 174.74 0 0 0 32.1-57.1 80 80 0 1 0 0-112 176.57 176.57 0 0 0-32.1-57.1 144.17 144.17 0 0 1 165.9-8.8l48.7-48.7-16.9-16.9A12 12 0 0 1 485 0h79a12 12 0 0 1 12 12z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M288 208a144 144 0 1 0-176 140.4V400H76a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h36v36a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-36h36a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12h-36v-51.6A144.12 144.12 0 0 0 288 208zm-144 80a80 80 0 1 1 80-80 80.11 80.11 0 0 1-80 80z","className":"fa-primary","key":2})]);
}

VenusMars.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = VenusMars;

VenusMars.default = VenusMars;
